module.exports = __webpack_public_path__ + "img/surfer1.0b909f5f.svg";